// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,    
  // API_URL: 'https://sinsim.portfolio-techhive.com/backend/',
  // API_URL: 'http://192.168.1.72:8000/',
  // API_URL: 'http://192.168.1.96:8001/',
  API_URL: 'https://sinsim.portfolio-techhive.com/backend/', // This url is of sales portal

  // API_URL: 'http://192.168.2.40:8000/'
  // API_URL: 'https://f7d3-2402-a00-173-2d75-69bc-f45d-8478-2c9c.ngrok-free.app/',
  // API_URL: 'http://192.168.1.124:8000/',
  // API_URL: 'https://sinsim.techhiveteam.com/sinsim/public/',
  firebase: {
    apiKey: "AIzaSyBcsbV5JbSqErE953aGnSbTBLbbLais5Fk",
    authDomain: "sinsim-notification.firebaseapp.com",
    databaseURL: "https://sinsim-notification-default-rtdb.firebaseio.com",
    projectId: "sinsim-notification",
    storageBucket: "sinsim-notification.appspot.com",
    messagingSenderId: "1015634448901",
    appId: "1:1015634448901:web:fbb9d7486ad9f60a43c26c",
    measurementId: "G-NCKFSJKXKR",
    vapidKey: "BNbMD43_grOyisVLvw9nIVfQlWZa4lLkEHXU9EUSZQA2uecE2yf1cAXokTBMwLeVz-3P9ucQOx3X8JTCcU1oyIg"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
